import { DEALER_CONDUCT_CONTENT } from "../data/dealer-conduct-content";
import SEO from "@/components/SEO";

export default function DealerCodeOfConduct() {
  return (
    <>
      <SEO
        title="Dealer Code of Conduct | Motosport Software"
        description="Review the dealer code of conduct for participating in the Motosport Software platform."
        url="https://motosportsoftware.com/dealer-code-of-conduct"
      />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <h1 className="text-[36px] font-bold leading-tight tracking-tight text-[#1F2A3A] mb-8">
          Dealer Code of Conduct
        </h1>
        <div className="prose prose-lg max-w-none">
          {DEALER_CONDUCT_CONTENT.sections.map((section, index) => (
            <div key={index} className="mb-8">
              <h2 className="text-2xl font-bold text-[#1F2A3A] mb-4">{section.title}</h2>
              {section.paragraphs.map((paragraph, pIndex) => (
                <p key={pIndex} className="mb-4 text-[#525A68]">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>
      </main>
    </>
  );
}
